const SUBDOMAIN_PATTERN = /^[a-z0-9][a-z0-9_]{1,61}[a-z0-9]$/;
const MAX_SUBDOMAIN_LENGTH = 63;

const RESERVED_SUBDOMAINS = new Set([
  "www",
  "admin",
  "api",
  "app",
  "mail",
  "support",
  "billing",
  "login",
  "register",
  "static",
  "cdn",
  "help",
  "status",
]);

const slugFromCompanyName = (companyName: string): string =>
  companyName
    .trim()
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "")
    .slice(0, MAX_SUBDOMAIN_LENGTH)
    .replace(/_+$/g, "");

export const randomThreeDigits = (): string =>
  String(Math.floor(Math.random() * 1000)).padStart(3, "0");

/** Append three digits, keeping the result inside the subdomain length limit. */
export const appendThreeDigits = (subdomain: string, digits: string): string => {
  const suffix = digits.replace(/\D/g, "").padStart(3, "0").slice(-3);
  const room = MAX_SUBDOMAIN_LENGTH - suffix.length;
  let base = subdomain.slice(0, room).replace(/_+$/g, "");
  if (!/^[a-z0-9]/.test(base)) {
    base = "co";
  }
  const candidate = `${base}${suffix}`;
  return SUBDOMAIN_PATTERN.test(candidate) ? candidate : `co${suffix}`;
};

/** Workspace id derived from the company name. Spaces become underscores. */
export const subdomainFromCompanyName = (companyName: string): string => {
  const slug = slugFromCompanyName(companyName);
  if (slug.length >= 3 && !RESERVED_SUBDOMAINS.has(slug) && SUBDOMAIN_PATTERN.test(slug)) {
    return slug;
  }
  const base = slug.length >= 1 && !RESERVED_SUBDOMAINS.has(slug) ? slug : "co";
  return appendThreeDigits(base, "000");
};
